// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--h3oTy","inner-wrapper":"_9e1425b4d3--inner-wrapper--SotRa"};